import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import SelectField from "../../../../components/common/form/SelectField";
import { createOptionListForSelectTag } from "../../../../helpers/utils/Utils";
import { OptionType } from "../../../../helpers/utils/StyleUtils";
import { useParams } from "react-router-dom";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import { useGetThirdPartyProviderByIdQuery, useUpdateThirdPartyProviderDetailApiMutation } from "../thirdPartyProvider";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import { useDispatch } from "react-redux";
import { tgxApi } from "../../../../app/tgxApi";

interface props {
    isReadOnly?: boolean;
}
const ThirdPartyProviderDetailInfo: FC<props> = ({ isReadOnly }) => {

    const dispatch = useDispatch();
    const { providerId } = useParams();
    const [providersData, setProviderData] = useState<any>({});
    const { data: providerData } = useGetThirdPartyProviderByIdQuery(providerId);
    const { data: enums } = useGetEnumsQuery("");
    const [showButtons, setShowButtons] = useState<boolean>(false);

    const [updateThirdPartyProviderDetailApi, updateThirdPartyProviderApiResponse] = useUpdateThirdPartyProviderDetailApiMutation()

    useEffect(() => {
        if (providerData) {
            const obj = providerData;
            setProviderData({
                ...obj,
                overrideAssociationStatus: obj?.overrideAssociationStatus
                    ? {
                        value: obj.overrideAssociationStatus,
                        label: getEnumDisplayNameByConstant(
                            enums?.["AssociationStatus"],
                            obj.overrideAssociationStatus
                        ),
                    }
                    : null,
            });
        }
    }, [providerData, enums]);

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const { name, value } = "target" in e ? e.target : e;
        setProviderData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
        setShowButtons(true);

    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let obj = {
            ...providersData,
            overrideAssociationStatus: providersData?.overrideAssociationStatus?.value || null
        }
        const UpdateSystemProperty = async () => {
            await updateThirdPartyProviderDetailApi({
                providerId: providerId,
                requestBody: obj,
            }).unwrap();
        };
        await handleRTKQuery(UpdateSystemProperty, () => {
            setShowButtons(false);
        });
    }
    const handCancel = async (e?: React.MouseEvent<HTMLButtonElement>) => {
        e?.preventDefault();
        dispatch(tgxApi.util.invalidateTags([
            "thirdPartyProviderById"
        ]));
        setShowButtons(false);
    };

    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm rounded-md">
            <Form
                onSubmit={handleSubmit}
                fields={
                    <>
                        <div className="flex justify-between items-center border-b bordder border-surface-7 p-2">
                            <h5 className="font-semibold text-surface-0">Third Party Provider Detail
                            </h5>
                            {showButtons && !isReadOnly && (
                                <ButtonTray
                                    buttons={[
                                        {
                                            buttonProps: {
                                                btnText: "Cancel",
                                                onClick: () => handCancel(),
                                                type: "close",
                                            },
                                            buttonType: "button"
                                        },
                                        {
                                            buttonProps: {
                                                btnText: "Submit",
                                                type: "submit",
                                                isLoading: (updateThirdPartyProviderApiResponse.isLoading),
                                            },
                                            buttonType: "button",
                                        }
                                    ]}
                                    align="end"
                                    gap={2}
                                />
                            )}
                        </div>
                        <div className={'p-2'}>
                            <InputField
                                name="name"
                                label="Name"
                                value={providersData?.name || ""}
                                onChange={handleOnChange}
                                required
                                placeholder="Enter Name..."
                                disabled={isReadOnly}
                            />

                            <InputField
                                name="website"
                                label="Website"
                                value={providersData?.website || ""}
                                onChange={handleOnChange}
                                placeholder="Enter Payable To..."
                                disabled={isReadOnly}
                            />

                            <SelectField
                                placeholder="Select Status..."
                                value={providersData?.overrideAssociationStatus || null}
                                options={createOptionListForSelectTag(enums?.["AssociationStatus"], "value", "constant")}
                                onChange={(selectedOption) => handleOnChange({ name: "overrideAssociationStatus", value: selectedOption })}
                                label="Override Association Status"
                                isDisabled={isReadOnly}
                            />
                        </div>
                    </>
                }
            />
        </div>
    );
};

export default ThirdPartyProviderDetailInfo;